export default {

    //заполнить данные по web пользователямбонусам в работе
    loadBonusInWork(state, data) {
        state.bonusesInWork = data;
    },

    //заполнить данные завершенным бонусам
    loadBonusComplited(state, data) {
        state.bonusesComplited = data;
    },


}
